import Offcanvas from "bootstrap/js/dist/offcanvas";
import { memo, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import LocaleNavLink from "views/components/LocaleNavLink";
import SocialNav from "views/components/SocialNav";

const RootAboutNavigation = () => {
	const location = useLocation();
	const { t } = useTranslation();

	// portal dom element
	let portalsRoot = document.getElementById("portals") || null;
	if (!portalsRoot) {
		portalsRoot = document.createElement("div");
		portalsRoot.setAttribute("id", "portals");
		document.body.appendChild(portalsRoot);
	}

	// ref hook
	const offCanvasRef = useRef(null);

	// effect hook
	useEffect(() => {
		const offCanvasCurrentElement = offCanvasRef?.current;
		let offcanvas = Offcanvas.getInstance(offCanvasCurrentElement);
		if (!offcanvas) offcanvas = new Offcanvas(offCanvasCurrentElement);
		return () => (offcanvas ? Offcanvas.getInstance(offCanvasCurrentElement).dispose() : false);
	}, [location]);

	return (
		portalsRoot &&
		ReactDOM.createPortal(
			<div
				id="root-about-navigation-offcanvas"
				className="offcanvas offcanvas-start border-0 shadow"
				tabIndex="-1"
				data-bs-scroll="true"
				aria-labelledby="root-about-navigation-offcanvas-label"
				ref={offCanvasRef}>
				<div className="offcanvas-header pb-0">
					<button
						className="btn btn-link link-primary-400 btn-lg text-uppercase border-0 ps-0 py-0 fs-4 text-decoration-none"
						data-bs-target="#root-navigation-offcanvas"
						data-bs-toggle="offcanvas"
						aria-controls="root-navigation-offcanvas"
						type="button">
						<span className="btn-icon text-black me-2">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="1em"
								height="1em"
								fill="currentColor"
								viewBox="0 0 16 16">
								<path
									fillRule="evenodd"
									d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
								/>
							</svg>
						</span>
						<span className="btn-text">
							<strong>{t("actions.about")}</strong>
						</span>
					</button>
					<button
						type="button"
						className="btn-close ms-auto"
						data-bs-dismiss="offcanvas"
						aria-label={t("actions.close")}></button>
				</div>
				<div className="offcanvas-body customized-scroll px-0 py-5">
					<div className="row gx-0 h-100 flex-column flex-nowrap gy-4">
						<div className="col-12 flex-grow-1">
							<nav className="root-home-nav h-100 w-100" aria-label="home about navigation">
								<ul
									className="nav row gx-3 gx-lg-2 flex-nowrap align-items-center h-100 w-100 flex-column gy-3"
									role="menu">
									<li className="nav-item col-auto" role="menuitem">
										<LocaleNavLink
											to="/team"
											className="btn btn-link nav-link link-primary-400 w-100 py-2 pe-2 ps-3 border-0 text-decoration-none rounded-pill text-uppercase fs-4">
											<small>
												<strong>{t("actions.our_team")}</strong>
											</small>
										</LocaleNavLink>
									</li>
									<li className="nav-item col-auto" role="menuitem">
										<LocaleNavLink
											to="/origins"
											className="btn btn-link nav-link link-primary-400 w-100 py-2 pe-2 ps-3 border-0 text-decoration-none rounded-pill text-uppercase fs-4">
											<small>
												<strong>{t("actions.our_origins")}</strong>
											</small>
										</LocaleNavLink>
									</li>
								</ul>
							</nav>
						</div>
						<div className="col-12">
							<SocialNav variant="primary" align="text-center" size="3" spacer="mx-3" />
						</div>
					</div>
				</div>
			</div>,
			portalsRoot
		)
	);
};

export default memo(RootAboutNavigation);
